import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteConfigContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/site-config`);
      setConfig(data);
    } catch (error) {
      console.error('Error fetching site config:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateConfig = async (updates) => {
    try {
      await axios.put(`${API_URL}/api/site-config`, updates, {
        withCredentials: true
      });
      await fetchConfig();
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  };

  return (
    <SiteConfigContext.Provider value={{ config, loading, updateConfig, fetchConfig }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => {
  const context = useContext(SiteConfigContext);
  if (!context) {
    throw new Error('useSiteConfig must be used within SiteConfigProvider');
  }
  return context;
};
